// extracted by mini-css-extract-plugin
module.exports =  {"pageWidthWrapper":"pageWidthWrapper_f_i_HvlT"};